import React from 'react';
import { s as styleInject } from '../../style-inject.es-746bb8ed.js';
import classNames from 'classnames';
import { Toggle } from 'wix-rich-content-ui-components';
import { KEYS_CHARCODE } from 'wix-rich-content-editor-common';

var css_248z = ".JZEa8,.glob_fontElementMap{font-family:var(--ricos-font-family,unset)}._5P8w5{color:var(--ricos-settings-text-color,#000);width:100%}[dir] ._5P8w5{background-color:#fff}@supports not (contain:inline-size){@media only screen and (max-width:640px){._5P8w5{height:47px}}}@container (width < 640px){._5P8w5{height:47px}}._5P8w5 .givpy{grid-gap:12px;align-items:center;display:grid;grid-auto-columns:max-content auto max-content;grid-auto-flow:column;height:40px;width:100%}[dir=ltr] ._5P8w5 .givpy,[dir=rtl] ._5P8w5 .givpy{padding-left:20px;padding-right:20px}._5P8w5 .givpy ._7rdPD{align-self:left}._5P8w5 .givpy .ylflz{display:grid;grid-auto-flow:row}._5P8w5 .givpy .ylflz .sV-e-{font-size:14px}._5P8w5 .givpy .ylflz .D6y8s{color:#646464;font-size:12px}._5P8w5 .givpy ._-8wTH{align-self:right}";
var styles = {"fontElementMap":"JZEa8","container":"_5P8w5","content":"givpy","prefix":"_7rdPD","titleWrapper":"ylflz","title":"sV-e-","subtitle":"D6y8s","suffix":"_-8wTH"};
styleInject(css_248z);

const ListItemToggle = ({
  title,
  subtitle,
  prefix,
  suffix,
  dataHook,
  selected,
  onChange
}) => {
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classNames(styles.container, {
        [styles.selected]: selected
      }),
      tabIndex: 0,
      onKeyDown: (e) => {
        if (e.keyCode === KEYS_CHARCODE.ENTER) {
          onChange == null ? void 0 : onChange();
          e.stopPropagation();
        }
      },
      "data-hook": dataHook,
      "data-selected": selected
    },
    /* @__PURE__ */ React.createElement("div", { className: styles.content }, prefix && /* @__PURE__ */ React.createElement("div", { className: styles.prefix }, prefix), /* @__PURE__ */ React.createElement("div", { className: styles.titleWrapper }, title && /* @__PURE__ */ React.createElement("div", { className: styles.title }, title), subtitle && /* @__PURE__ */ React.createElement("div", { className: styles.subtitle }, subtitle)), suffix && /* @__PURE__ */ React.createElement("div", { className: styles.suffix }, suffix), /* @__PURE__ */ React.createElement(Toggle, { checked: selected, onChange, dataHook }))
  );
};

export { ListItemToggle as default };
//# sourceMappingURL=ListItemToggle.js.map
